import React, { useState } from "react";
import { useApp, formatBRL } from "../context/AppContext";
import { Button } from "../components/ui/button";
import { useToast } from "../hooks/use-toast";
import { Tag, Plus, Trash2, Pencil } from "lucide-react";

const inputCls = "w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-blue-500";

const ServicosExtras = () => {
  const { data, salvarServicoExtra, excluirServicoExtra } = useApp();
  const { toast } = useToast();
  const lista = data?.servicosExtras || [];
  const [form, setForm] = useState({ id: null, nome: "", valor: "" });

  const salvar = async () => {
    if (!form.nome.trim() || form.valor === "") { toast({ title: "Informe nome e valor do serviço" }); return; }
    await salvarServicoExtra({ id: form.id, nome: form.nome.trim(), valor: Number(form.valor) });
    setForm({ id: null, nome: "", valor: "" });
    toast({ title: form.id ? "Serviço atualizado" : "Serviço cadastrado" });
  };

  return (
    <div className="space-y-6" data-testid="servicos-extras-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2"><Tag className="w-6 h-6 text-emerald-600" /> Serviços Extras</h1>
        <p className="text-sm text-slate-500">Catálogo de serviços (ex.: Fisioterapia, Corte de cabelo). Podem ser cobrados de forma avulsa na fatura ou de forma recorrente na mensalidade — isso é definido na ficha de cada residente.</p>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5">
        <div className="grid grid-cols-1 sm:grid-cols-12 gap-3 items-end">
          <div className="sm:col-span-6">
            <label className="text-xs font-medium text-slate-500">Nome do serviço</label>
            <input className={inputCls} value={form.nome} onChange={(e) => setForm((f) => ({ ...f, nome: e.target.value }))} placeholder="Ex.: Fisioterapia" data-testid="sx-nome" />
          </div>
          <div className="sm:col-span-4">
            <label className="text-xs font-medium text-slate-500">Valor (R$)</label>
            <input type="number" step="0.01" className={inputCls} value={form.valor} onChange={(e) => setForm((f) => ({ ...f, valor: e.target.value }))} data-testid="sx-valor" />
          </div>
          <div className="sm:col-span-2 flex gap-2">
            <Button className="bg-emerald-600 hover:bg-emerald-700 gap-1.5 w-full" onClick={salvar} data-testid="sx-salvar"><Plus className="w-4 h-4" /> {form.id ? "Salvar" : "Adicionar"}</Button>
            {form.id && <Button variant="outline" onClick={() => setForm({ id: null, nome: "", valor: "" })}>Cancelar</Button>}
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm divide-y divide-slate-100" data-testid="sx-lista">
        {lista.length === 0 && <p className="text-sm text-slate-400 px-5 py-4">Nenhum serviço cadastrado.</p>}
        {lista.map((s) => (
          <div key={s.id} className="flex items-center justify-between px-5 py-3" data-testid={`sx-item-${s.id}`}>
            <span className="font-medium text-slate-700">{s.nome}</span>
            <div className="flex items-center gap-4">
              <span className="text-sm font-semibold text-slate-700">{formatBRL(s.valor)}</span>
              <button onClick={() => setForm({ id: s.id, nome: s.nome, valor: s.valor })} className="text-slate-300 hover:text-blue-600" data-testid={`sx-edit-${s.id}`}><Pencil className="w-4 h-4" /></button>
              <button onClick={() => excluirServicoExtra(s.id)} className="text-slate-300 hover:text-red-500" data-testid={`sx-del-${s.id}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicosExtras;
